import React, { useEffect } from 'react';
import { Moment } from "moment";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import DateFlicker, { DateScale } from "./DateFlicker";
import { BodyRegular } from "../atoms/fonts/Body";
import { selectActiveDay, setActiveDay } from '@features/whereabouts/store/editMovements.duck';
import { getParameterByName } from '@shared/utils/UrlUtils';
import { WithDaysInWorkWeek } from '@shared/hooks/WithDaysInWorkWeek';
import { selectCalendarDate, setCalendarDate } from '@shared/store/dashboard.duck';
import { Column } from "../atoms/StructuralLayout";
import { desktopSmall, smallTablet } from "../atoms/MediaQueries";
import Colours from "../atoms/Colours";
import { PageTitle } from "../atoms/PageTitle";
import { OfficeListSidebar } from "@features/whereabouts/pages/company-movements/components/daily-office-list-view/OfficeListSidebar";
import { TabletOnly } from "../atoms/DeviceSpecific";

export function ContainerViewDateWrapper(props: Props) {
  const dispatch = useDispatch();
  const currentWeek = WithDaysInWorkWeek();
  const selectedDate = useSelector(selectActiveDay);
  const globalDate = useSelector(selectCalendarDate);

  useEffect(() => {
    const date = getParameterByName('date', window.location.href);
    if (date) {
      try {
        dispatch(setActiveDay(moment(date)));
      } catch (e) {
      }
    }
  }, [dispatch])

  const onDateChange = (date: Moment) => {
    dispatch(setActiveDay(date));
    dispatch(setCalendarDate(date));
  }

  return (
    <OfficeUsageViewWrapper>
      {props.title && <PageTitle text={props.title} showTodayButton={true} />}
      <TabletOnly>
        <OfficeListSidebar />
      </TabletOnly>

      <DateNavigation>
        <DateFlickerWrapper>
          <DateFlicker date={globalDate} dateScale={DateScale.Week} updateGlobalDate={true} restrictPastWhereabouts={true} onChange={onDateChange} />
        </DateFlickerWrapper>
        <WeekHeader data-test="office-week-header">
          {currentWeek.map((day: Moment, key: number) =>
            <DayHeader key={key} isActive={day.format('YYYYMMDD') === selectedDate?.format('YYYYMMDD')} onClick={() => onDateChange(day)}>
              <BodyRegular weight={600}>{day.format('ddd')}</BodyRegular>
              <BodyRegular weight={600}>{day.format('D')}</BodyRegular>
            </DayHeader>)}
        </WeekHeader>
      </DateNavigation>
      <ChildContainer>
        {props.children}
      </ChildContainer>
    </OfficeUsageViewWrapper>
  )
}

interface Props {
  title?: string;
  children: any;
}

const OfficeUsageViewWrapper = styled(Column)`
  @media (${smallTablet}) {
    padding-right: 32px;
  }
`

const DayHeader = styled.div<any>`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.isActive ? Colours.veryLightGrey : 'transparent'};
  min-height: 64px;
  flex: 1;
  justify-content: center;
  align-items: center;
  border: ${props => props.isActive ? `solid 2px ${Colours.mildGrey}` : ``};
  border-bottom: ${props => props.isActive ? `solid 2px ${Colours.veryLightGrey}` : `none`};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  z-index: 9;
  cursor: pointer;
  p {
    line-height: normal;
    color: ${props => props.isActive ? Colours.blue : Colours.darkGrey};
  }
`

const ChildContainer = styled.div`
  border: 2px solid ${Colours.mildGrey};
  border-radius: 12px;
  min-height: 500px;
  width: 100%;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  margin-top: -2px;
`

const DateNavigation = styled.div`
  display: flex;
  flex-direction: column;
  @media (${desktopSmall}) {
    flex-direction: row;
    margin-top: 24px;
  }
`

const DateFlickerWrapper = styled.div`
  width: 100%;
  margin-bottom: 12px;
  @media (${desktopSmall}) {
    width: 25%;
    margin-bottom: 0;
  }
`

const WeekHeader = styled.div`
  min-height: 64px;
  display: flex;
  flex: 1;
`
